var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_616_1157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.72102 10.2899C1.65159 10.1028 1.65159 9.89709 1.72102 9.71005C2.39722 8.07046 3.54503 6.66856 5.01894 5.68209C6.49284 4.69562 8.22647 4.16901 10 4.16901C11.7736 4.16901 13.5072 4.69562 14.9811 5.68209C16.455 6.66856 17.6028 8.07046 18.279 9.71005C18.3485 9.89709 18.3485 10.1028 18.279 10.2899C17.6028 11.9295 16.455 13.3314 14.9811 14.3178C13.5072 15.3043 11.7736 15.8309 10 15.8309C8.22647 15.8309 6.49284 15.3043 5.01894 14.3178C3.54503 13.3314 2.39722 11.9295 1.72102 10.2899Z",
    stroke: "#F0E1CE",
    strokeOpacity: 0.5,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 12.4992C11.3802 12.4992 12.4991 11.3803 12.4991 9.99999C12.4991 8.61972 11.3802 7.50079 9.99993 7.50079C8.61966 7.50079 7.50073 8.61972 7.50073 9.99999C7.50073 11.3803 8.61966 12.4992 9.99993 12.4992Z",
    stroke: "#F0E1CE",
    strokeOpacity: 0.5,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_616_1157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9936,
    height: 19.9936,
    fill: "white",
    transform: "translate(0.00317383 0.00317383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/Button.986d4fb04f609583fdb5d44e0f2b6fff.svg";
export { ForwardRef as ReactComponent };